/**
 * copy from https://github.com/Interencheres/asgard/blob/master/utils/slugify.ts
 * slugify a string
 * @param value
 */
const slugify = (value: string | number) => {
    if ([undefined, null].includes(value)) {
        return;
    }
    return value
        .toString()
        .replace(/ẞ/g, "ss") // lowercase value is really different "Ṿ" so we replace it before
        .toLowerCase()
        .replace(/[àáâãäå]/g, "a")
        .replace(/æ/g, "ae")
        .replace(/ç/g, "c")
        .replace(/[èéêë]/g, "e")
        .replace(/[ìíîï]/g, "i")
        .replace(/ñ/g, "n")
        .replace(/[òóôõö]/g, "o")
        .replace(/œ/g, "oe")
        .replace(/[ùúûü]/g, "u")
        .replace(/[ýÿ]/g, "y")
        .replace(/ß/g, "ss")
        .replace(/€/g, "eur")
        .replace(/&/g, "-et-")
        .replace(/\s+/g, "-")
        .replace(/[^\w-]+/g, "")
        .replace(/--+/g, "-")
        .replace(/^-+/g, "")
        .replace(/-+$/g, "");
};
export default slugify;
